module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vux-nuxt-ssr-293.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/development/vux-nuxt-ssr.md
// module id = 738
// module chunks = 194